import React, { useState } from 'react';
import logo from '../assets/logo.png';
import { PageType, SimulationData } from '../App';

interface NavbarProps {
  currentPage: PageType;
  setCurrentPage: (page: PageType) => void;
  onLoginClick: () => void;
  onStartSimulation: (data?: SimulationData) => void;
}

const Navbar: React.FC<NavbarProps> = ({ currentPage, setCurrentPage, onLoginClick, onStartSimulation }) => {
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);

  return (
    <nav className="nav">
      <div className="nav-logo" onClick={() => setCurrentPage('home')}>
        <img src={logo} alt="Market Entry Logo" className="nav-logo-img" />
        <span>Market Entry</span>
      </div>
      <div className="nav-links">
        <a onClick={() => setCurrentPage('home')} className={currentPage === 'home' ? 'active' : ''}>Home</a>
        <div className="nav-dropdown">
          <a className="nav-dropdown-trigger">
            Use Cases
            <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </a>
          <div className="nav-dropdown-menu">
            <div className="nav-dropdown-menu-inner">
              <a onClick={() => setCurrentPage('founder')}>
                <span className="dd-title">Entrepreneur / Founder</span>
                <span className="dd-desc">Simulate your market entry before you invest</span>
              </a>
              <a onClick={() => setCurrentPage('executive')}>
                <span className="dd-title">CEO / CFO</span>
                <span className="dd-desc">Validate target markets and optimize entry structure</span>
              </a>
              <a onClick={() => setCurrentPage('investor')}>
                <span className="dd-title">VC / PE Investment Manager</span>
                <span className="dd-desc">Validate portfolio expansion plans with data</span>
              </a>
              <a onClick={() => setCurrentPage('comparison')}>
                <span className="dd-title">Market Comparison</span>
                <span className="dd-desc">Find the best market automatically</span>
              </a>
            </div>
          </div>
        </div>
        <a onClick={() => setCurrentPage('about')}>About Us</a>
        <a onClick={() => setCurrentPage('contact')}>Contact</a>
      </div>
      <div className="nav-right">
        <button className="btn-login" onClick={onLoginClick}>Log In</button>
        <button className="btn-cta" onClick={() => onStartSimulation()}>Get Free Simulation</button>
        <button className="mobile-menu-btn" onClick={() => setMobileOpen(!mobileOpen)}>
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      </div>
      {mobileOpen && (
        <div className="mobile-menu">
          <a onClick={() => { setCurrentPage('home'); setMobileOpen(false); }}>Home</a>
          <a onClick={() => { setCurrentPage('founder'); setMobileOpen(false); }}>Entrepreneur / Founder</a>
          <a onClick={() => { setCurrentPage('executive'); setMobileOpen(false); }}>CEO / CFO</a>
          <a onClick={() => { setCurrentPage('investor'); setMobileOpen(false); }}>VC / PE Investment</a>
          <a onClick={() => { setCurrentPage('comparison'); setMobileOpen(false); }}>Market Comparison</a>
          <a onClick={() => { setCurrentPage('about'); setMobileOpen(false); }}>About Us</a>
          <a onClick={() => { setCurrentPage('contact'); setMobileOpen(false); }}>Contact</a>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '4px' }}>
            <button className="btn-login" style={{ width: '100%', padding: '12px', fontSize: '14px', borderRadius: '10px', display: 'block' }} onClick={() => { onLoginClick(); setMobileOpen(false); }}>Log In</button>
            <button className="btn-cta" style={{ width: '100%', padding: '12px', fontSize: '14px', borderRadius: '10px' }} onClick={() => { onStartSimulation(); setMobileOpen(false); }}>Get Free Simulation</button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
